import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

import balanceReminderSessionStorage, { BalanceReminderPayloadKey } from './balanceReminderSessionStorage';

const useGetBalanceReminderQuery = () => {
  const { data, isLoading, isSuccess } = useQuery([API_URL.EMPLOYEES_BALANCE_REMINDER], () =>
    api.get(API_URL.EMPLOYEES_BALANCE_REMINDER)
  );

  const formattedData = useMemo(
    () => ({
      thirtyDaysBeforeBanner: balanceReminderSessionStorage.getThirtyDays()
        ? false
        : data?.data?.[BalanceReminderPayloadKey.thirtyDays],
    }),
    [data]
  );

  return {
    formattedData,
    isLoading,
    isSuccess,
  };
};

export default useGetBalanceReminderQuery;
